import React from 'react';
import { Container, Row } from 'react-bootstrap';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import DefaultTabsBorderedBottom from './DefaultTabsBorderedBottom';
import Search from './Search';

const Agent = () => (
  <div>
    <Container>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
        marginBottom: '5px',
      }}
      >
        <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
        <Typography sx={{ color: 'text.primary' }}>Agent</Typography>
        <Typography sx={{ color: 'text.primary' }}>Search</Typography>
      </Breadcrumbs>
    </Container>
   
    <Container className="bg-white">
      
      <Search />
    </Container>
  </div>
 
  
);

export default Agent;
